// import React from 'react';
// import { Link } from 'react-router-dom';
// import './DownloadsPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function DownloadsPage() {
//   const downloadCategories = [
//     {
//       id: 'admission',
//       title: 'Admission Documents',
//       icon: '📋',
//       themeClass: 'theme-blue',
//       items: [
//         { title: 'Prospectus AY 2025–26', meta: 'PDF • 4.2 MB', isNew: true },
//         { title: 'Application Form (July Session 2025)', meta: 'PDF • 1.1 MB', isNew: true },
//         { title: 'Admission Guidelines 2025–26', meta: 'PDF • 890 KB', isNew: false },
//         { title: 'Fee Structure 2025–26', meta: 'PDF • 420 KB', isNew: true }
//       ]
//     },
//     {
//       id: 'study-materials',
//       title: 'Study Materials',
//       icon: '📖',
//       themeClass: 'theme-purple',
//       items: [
//         { title: 'BA First Year Study Material (Tamil Medium)', meta: 'PDF • 12 MB', isNew: false },
//         { title: 'BCom Study Material – Accountancy', meta: 'PDF • 8.5 MB', isNew: false },
//         { title: 'MBA Business Management Module 1', meta: 'PDF • 15 MB', isNew: false },
//         { title: 'BCA Programming in C Study Guide', meta: 'PDF • 9.2 MB', isNew: false }
//       ]
//     },
//     {
//       id: 'examination',
//       title: 'Examination',
//       icon: '📄',
//       themeClass: 'theme-orange',
//       items: [
//         { title: 'April/May 2025 Exam Time Table', meta: 'PDF • 580 KB', isNew: false },
//         { title: 'October 2025 Exam Schedule', meta: 'PDF • 580 KB', isNew: true },
//         { title: 'Hall Ticket Generation Guidelines', meta: 'PDF • 300 KB', isNew: false },
//         { title: 'Examination Centre List 2025', meta: 'PDF • 1.2 MB', isNew: false }
//       ]
//     },
//     {
//       id: 'assignment',
//       title: 'Assignment',
//       icon: '📝',
//       themeClass: 'theme-green',
//       items: [
//         { title: 'Assignment Topics – UG Programs (2024–25)', meta: 'PDF • 1.5 MB', isNew: false },
//         { title: 'Assignment Topics – PG Programs (2024–25)', meta: 'PDF • 1.8 MB', isNew: false },
//         { title: 'Assignment Submission Guidelines', meta: 'PDF • 450 KB', isNew: false },
//         { title: 'Assignment Format Template', meta: 'DOCX • 280 KB', isNew: false }
//       ]
//     },
//     {
//       id: 'results',
//       title: 'Results',
//       icon: '🏅',
//       themeClass: 'theme-blue',
//       items: [
//         { title: 'April/May 2025 Results Gazette', meta: 'PDF • 6.8 MB', isNew: true },
//         { title: 'January 2025 Results Gazette', meta: 'PDF • 5.9 MB', isNew: false },
//         { title: 'Grade & Credit System Guidelines', meta: 'PDF • 750 KB', isNew: false }
//       ]
//     },
//     {
//       id: 'certificates',
//       title: 'Certificates & Transcripts',
//       icon: '📅',
//       themeClass: 'theme-brown',
//       items: [
//         { title: 'Provisional Certificate Application Form', meta: 'PDF • 340 KB', isNew: false },
//         { title: 'Transcript Request Form', meta: 'PDF • 380 KB', isNew: false },
//         { title: 'Migration Certificate Application', meta: 'PDF • 290 KB', isNew: false },
//         { title: 'Degree Certificate Verification Form', meta: 'PDF • 310 KB', isNew: false }
//       ]
//     }
//   ];

//   return (
//         <>
//              <Navbar />
//     <div className="downloads-page-wrapper">
      
//       {/* 1. Hero Banner */}
//       <section className="downloads-hero-banner">
//         <div className="banner-inner-container">
//           <nav className="breadcrumb-nav">
//             <Link to="/" className="breadcrumb-link">Home</Link> / <span>Downloads</span>
//           </nav>
//           <h1>Downloads</h1>
//           <p>Access and download all important forms, documents, study materials, and guides.</p>
//         </div>
//       </section>

//       {/* 2. Main Downloads Grid */}
//       <section className="downloads-grid-section">
//         <div className="downloads-container">
          
//           <div className="downloads-cards-grid">
//             {downloadCategories.map((cat) => (
//               <div key={cat.id} className="download-category-card">
                
//                 {/* Category Header */}
//                 <div className={`category-card-header ${cat.themeClass}`}>
//                   <span className="category-icon">{cat.icon}</span>
//                   <h2>{cat.title}</h2>
//                 </div>

//                 {/* Items List */}
//                 <div className="download-items-list">
//                   {cat.items.map((item, idx) => (
//                     <div key={idx} className="download-row-item">
                      
//                       <div className="item-info-left">
//                         <span className="file-icon">📄</span>
//                         <div className="title-meta-block">
//                           <span className="doc-title">{item.title}</span>
//                           <span className="doc-meta">{item.meta}</span>
//                         </div>
//                       </div>

//                       <div className="item-action-right">
//                         {item.isNew && <span className="badge-new">NEW</span>}
//                         <button className={`btn-download-action ${cat.themeClass}-btn`}>
//                           <span className="dl-icon">📥</span> Download
//                         </button>
//                       </div>

//                     </div>
//                   ))}
//                 </div>

//               </div>
//             ))}
//           </div>

//           {/* 3. Bottom Assistance Banner */}
//           <div className="help-assistance-banner">
//             <div className="help-banner-left">
//               <span className="help-icon">📄</span>
//               <div className="help-text">
//                 <h3>Need Help Finding a Document?</h3>
//                 <p>If you cannot find the document you need, contact our CDOE office or visit your nearest study centre.</p>
//               </div>
//             </div>
//             <a href="/contact-enquiry" className="btn-contact-us">Contact Us</a>
//           </div>

//         </div>
//       </section>

//     </div>
//       <FooterSection/>
//                 </>
//   );
// }



import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './DownloadsPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

const API_URL = 'https://metapi.emedhatechnologies.com/api/courses/api/downloads';
const SERVER_BASE = 'https://metapi.emedhatechnologies.com';



export default function DownloadsPage() {
  const [downloadCategories, setDownloadCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Category Configuration
  const categoryConfig = {
    'Admission Documents': { icon: '📋', themeClass: 'theme-blue' },
    'Study Materials': { icon: '📖', themeClass: 'theme-purple' },
    'Examination': { icon: '📄', themeClass: 'theme-orange' },
    'Assignment': { icon: '📝', themeClass: 'theme-green' },
    'Results': { icon: '🏅', themeClass: 'theme-blue' },
    'Certificates & Transcripts': { icon: '📅', themeClass: 'theme-brown' },
  };

  // Helper Function: Formats ISO timestamp to human readable date and time
  const formatDisplayDateTime = (dateStr, timeStr) => {
    if (!dateStr) return '';
    
    // Combine date and time if timeStr exists, or handle ISO timestamp directly
    const isoString = timeStr ? `${dateStr.split('T')[0]}T${timeStr}` : dateStr;
    const dateObj = new Date(isoString);

    if (isNaN(dateObj.getTime())) return dateStr;

    return dateObj.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  // Fetch API and Group Data dynamically by Header Title
  const fetchDownloads = async () => {
    try {
      const res = await fetch(API_URL);
      const rawData = await res.json();

      // Grouping flat list into Categories
      const grouped = rawData.reduce((acc, item) => {
        const catName = item.header_title || 'General';
        
        if (!acc[catName]) {
          const config = categoryConfig[catName] || { icon: '📂', themeClass: 'theme-blue' };
          acc[catName] = {
            id: catName.toLowerCase().replace(/[^a-z0-9]/g, '-'),
            title: catName,
            icon: config.icon,
            themeClass: config.themeClass,
            items: [],
          };
        }

        // Format Date & Time output
        const formattedDateTime = formatDisplayDateTime(item.created_date, item.created_time);

        acc[catName].items.push({
          id: item.id,
          title: item.title,
          meta: `${item.file_size || 'PDF'} • Posted ${formattedDateTime}`,
          isNew: Boolean(item.is_new),
          filePath: item.file_path,
        });

        return acc;
      }, {});

      setDownloadCategories(Object.values(grouped));
    } catch (err) {
      console.error('Error loading downloads:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDownloads();
  }, []);

  // Download Trigger Handler
  const handleDownload = (filePath, fileName) => {
    const link = document.createElement('a');
    link.href = `${SERVER_BASE}${filePath}`;
    link.download = fileName || 'download';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Navbar />
      <div className="downloads-page-wrapper">
        
        {/* 1. Hero Banner */}
        <section className="downloads-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Downloads</span>
            </nav>
            <h1>Downloads</h1>
            <p>Access and download all important forms, documents, study materials, and guides.</p>
          </div>
        </section>

        {/* 2. Main Downloads Grid */}
        <section className="downloads-grid-section">
          <div className="downloads-container">
            
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px 0', fontSize: '18px', color: '#64748b' }}>
                Loading documents...
              </div>
            ) : downloadCategories.length > 0 ? (
              <div className="downloads-cards-grid">
                {downloadCategories.map((cat) => (
                  <div key={cat.id} className="download-category-card">
                    
                    {/* Category Header */}
                    <div className={`category-card-header ${cat.themeClass}`}>
                      <span className="category-icon">{cat.icon}</span>
                      <h2>{cat.title}</h2>
                    </div>

                    {/* Items List */}
                    <div className="download-items-list">
                      {cat.items.map((item) => (
                        <div key={item.id} className="download-row-item">
                          
                          <div className="item-info-left">
                            <span className="file-icon">📄</span>
                            <div className="title-meta-block">
                              <span className="doc-title">{item.title}</span>
                              <span className="doc-meta">{item.meta}</span>
                            </div>
                          </div>

                          <div className="item-action-right">
                            {item.isNew && <span className="badge-new">NEW</span>}
                            <button
                              className={`btn-download-action ${cat.themeClass}-btn`}
                              onClick={() => handleDownload(item.filePath, item.title)}
                            >
                              <span className="dl-icon">📥</span> Download
                            </button>
                          </div>

                        </div>
                      ))}
                    </div>

                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 0', fontSize: '18px', color: '#64748b' }}>
                No documents available for download at this time.
              </div>
            )}

            {/* 3. Bottom Assistance Banner */}
            <div className="help-assistance-banner">
              <div className="help-banner-left">
                <span className="help-icon">📄</span>
                <div className="help-text">
                  <h3>Need Help Finding a Document?</h3>
                  <p>If you cannot find the document you need, contact our CDOE office or visit your nearest study centre.</p>
                </div>
              </div>
              <a href="/contact-enquiry" className="btn-contact-us">Contact Us</a>
            </div>

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}